module.exports = __webpack_public_path__ + "img/SMT_58_Wan_Chen_Kang.193f354d.jpg";